import React, { SVGProps } from "react";

export const AdinOne = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={236}
    height={235}
    viewBox="0 0 236 235"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={117.972}
      cy={117.566}
      r={117.359}
      fill="white"
      fillOpacity={0.59}
    />
    <path
      d="M212.611 116.984L162.357 104.005C159.193 103.184 157.692 99.5672 159.355 96.7599L185.713 52.0582C186.566 50.6222 184.936 48.9918 183.5 49.8448L138.795 76.2015C135.977 77.8643 132.36 76.3634 131.55 73.1998L118.571 22.9374C118.149 21.3177 115.86 21.3177 115.439 22.9374L102.46 73.189C101.639 76.3526 98.0218 77.8535 95.2143 76.1907L50.4993 49.834C49.0632 48.981 47.4327 50.6114 48.2857 52.0474L74.6439 96.7491C76.3068 99.5565 74.8059 103.184 71.642 103.994L21.3876 116.984C19.7679 117.405 19.7679 119.694 21.3876 120.115L71.642 133.093C74.8059 133.914 76.3068 137.531 74.6439 140.339L48.2857 185.04C47.4327 186.476 49.0632 188.107 50.4993 187.254L95.2035 160.897C98.011 159.234 101.639 160.735 102.449 163.899L115.428 214.15C115.849 215.77 118.139 215.77 118.56 214.15L131.539 163.899C132.36 160.735 135.977 159.234 138.785 160.897L183.489 187.254C184.925 188.107 186.555 186.476 185.702 185.04L159.344 140.339C157.681 137.531 159.182 133.903 162.346 133.093L212.6 120.115C214.22 119.694 214.22 117.405 212.6 116.984H212.611ZM117.005 143.772C103.075 143.772 91.7805 132.478 91.7805 118.549C91.7805 104.62 103.075 93.3263 117.005 93.3263C130.934 93.3263 142.229 104.62 142.229 118.549C142.229 132.478 130.934 143.772 117.005 143.772Z"
      fill="#169FED"
    />
  </svg>
);
